import { Separator } from "Components/ui/separator";
import { Skeleton } from "Components/ui/skeleton";
import React from "react";
import { useSelector } from "react-redux";
import { formatDate } from "utils";

function ChallengeInfo() {
  const {
    challengeStageInfo,
    challengeStageInfoSuccess,
    challengeStageInfoError,
    challengeCurrency,
    challengeStageInfoLoading,
  } = useSelector((state) => state.ChallengeOverviewReducer);
  return (
    <div className="flex flex-col  w-full  p-5 px-6  rounded-lg  flex-1 bg-background border-2  border-border-darkNew ">
      <div className="flex justify-between items-end">
        <div className="flex flex-col gap-1 w-full border-b-2 border-border-darkNew pb-3 ">
          <span className="text-xl text-white font-N_Roman">
            Challenge Info
          </span>
          <div className="text-base font-N_Roman flex items-center gap-2 text-white-opacity">
            Here's some quick useful information about your current challenge
          </div>
        </div>
      </div>
      <div className="flex items-stretch justify-between mt-6 gap-6 flex-wrap">
        <div className="flex flex-col   p-4 px-6 rounded-lg  flex-1 bg-background border-2  border-border-darkNew min-w-[200px] ">
          <div className="text-white-opacity text-sm"> Start</div>

          {challengeStageInfoLoading ? (
            <Skeleton className="h-6 w-32" />
          ) : (
            <div className="text-white  text-base font-N_Bold">
              {challengeStageInfo?.createdAt
                ? formatDate(challengeStageInfo?.createdAt)
                : "-"}
            </div>
          )}
        </div>
        <div className="flex flex-col   p-4 px-6 rounded-lg  flex-1 bg-background border-2  border-border-darkNew min-w-[200px]">
          <div className="text-white-opacity text-sm"> End</div>
          {challengeStageInfoLoading ? (
            <Skeleton className="h-6 w-32" />
          ) : (
            <div className="text-white  text-base font-N_Bold">
              {challengeStageInfo?.endDate
                ? formatDate(challengeStageInfo?.endDate)
                : "-"}
            </div>
          )}
        </div>
        <div className="flex flex-col    p-4 px-6 rounded-lg  flex-1 bg-background border-2  border-border-darkNew min-w-[200px] ">
          <div className="text-white-opacity text-sm"> Account Size</div>
          {challengeStageInfoLoading ? (
            <Skeleton className="h-6 w-32" />
          ) : (
            <div className="text-white  text-base font-N_Bold">
              {challengeStageInfo?.Challenge?.Balance?.amount
                ? challengeStageInfo?.Challenge?.Balance?.amount?.toLocaleString(
                    "en-US",
                    { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                  )
                : "-"}{" "}
              {challengeCurrency}
            </div>
          )}
        </div>
        <div className="flex flex-col  p-4 px-6 rounded-lg  flex-1 bg-background border-2  border-border-darkNew min-w-[200px]">
          <div className="text-white-opacity text-sm"> Account Type</div>
          {challengeStageInfoLoading ? (
            <Skeleton className="h-6 w-24" />
          ) : (
            <div className="text-white  text-base font-N_Bold">
              {challengeStageInfo?.Challenge?.ChallengeType?.name || "-"}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ChallengeInfo;
